<edu-layout-standard-page
  *transloco="let t"
  [header]="t('routes.internal.settings.title')"
  [subheader]="t('routes.internal.settings.subtitle')"
>
  <div class="mb-6">
    <edu-page-menu [menuContents]="settingsMenuItems" />
  </div>

  <router-outlet />
</edu-layout-standard-page>
